import { useState, useEffect } from 'react';

export function useEvents(region) {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadEvents();
    }, [region]);

    const loadEvents = async () => {
        try {
            setLoading(true);

            const apiUrl = process.env.REACT_APP_API_URL_NODE;
            const url = region
                ? `${apiUrl}/api/events?region=${region}`
                : `${apiUrl}/api/events`;

            const response = await fetch(url);
            const data = await response.json();

            setEvents(data.events || []);
            setError(null);
        } catch (err) {
            console.error('Errore caricamento eventi:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const getEventsForTrail = (trailId) => {
        return events.filter(e => e.trail?.id === trailId);
    };

    const hasEvents = (trailId) => {
        return getEventsForTrail(trailId).length > 0;
    };

    return { events, loading, error, loadEvents, getEventsForTrail, hasEvents };
}